module.exports = __webpack_public_path__ + "static/media/sv-SE.f42f4819.md";